const formats = {
  DEFAULT: {
    // time: '', --> Do not use. This is handled via momentjs Local aware format LT option - https://momentjs.com/docs/#/parsing/string-format/
    dateFull: 'D MMM, YYYY',
    dateShort: 'D MMM',
    dateCalendar: 'D.MM.YYYY.',
    el_date_picker_format: 'dd.MM.yyyy', // element-ui has different formating placeholders than moment js
  },
  US: {
    dateFull: 'MMM D, YYYY',
    dateShort: 'MMM D',
    dateCalendar: 'MM/D/YYYY',
    el_date_picker_format: 'MM/dd/yyyy', // element-ui has different formating placeholders than moment js
  },
};

const countryFormatsMapping = {
  US: ['US', 'PH', 'PW', 'CA', 'FM'],
};

function getFormat(countryCode) {
  const targetFormat = Object.keys(countryFormatsMapping).find(key => countryFormatsMapping[key].includes(countryCode.toUpperCase()));
  if (targetFormat) {
    return formats[targetFormat];
  }
  return formats.DEFAULT;
}

export default getFormat;
